import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

/** Installation times use UTC. */
export const formatInstallationTimestamp = (value: string) =>
  `${dayjs.utc(value).format("YYYY-MM-DD HH:mm:ss")} UTC`;

export const installationInstant = (timestamp: string) => {
  const fraction = /\.(\d+)/.exec(timestamp)?.[1] ?? "";
  return (
    dayjs(timestamp).valueOf() +
    Number(fraction.padEnd(6, "0").slice(3, 6)) / 1000
  );
};
